import { AlertTriangle } from "lucide-react";

export default function ErrorList({ errors, title = "Errors", testId }) {
    if (!errors || errors.length === 0) return null;
    return (
        <div
            data-testid={testId || "error-list"}
            className="rounded-md border border-ux-danger/40 bg-ux-danger-soft text-ux-text-1 p-3 text-[13px]"
        >
            <div className="flex items-center gap-2 font-medium mb-2 text-ux-danger">
                <AlertTriangle className="w-4 h-4" />
                {title} ({errors.length})
            </div>
            <ul className="space-y-1">
                {errors.map((e, i) => (
                    <li key={i} className="font-mono text-[12px] tabular-nums">
                        <span className="text-ux-text-3">
                            {(e.loc || []).join(".") || "(root)"} →
                        </span>{" "}
                        <span className="text-ux-text-1">{e.msg}</span>{" "}
                        <span className="text-ux-text-3">({e.type})</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
